import { render, staticRenderFns } from "./ArticleTimeline.vue?vue&type=template&id=787c94cd&"
import script from "./ArticleTimeline.vue?vue&type=script&lang=ts&"
export * from "./ArticleTimeline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports